export default function countObjectValues(data, key, filter) {
  if (filter) {
    data = data.filter((x) => x[filter]);
  }

  return data.reduce((a, b) => {
    return a + b[key];
  }, 0);
}